"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var report_view_styles_1 = require("./report-view-styles");
var column_formatting_rule_converter_1 = require("../../../sis-tabular-report-options/converter/column-formatting-rule-converter");
var row_formatting_rule_converter_1 = require("../../../sis-tabular-report-options/converter/row-formatting-rule-converter");
var text_style_converter_1 = require("../../../sis-tabular-report-options/converter/text-style-converter");
var numbering_style_converter_1 = require("../../../sis-tabular-report-options/converter/numbering-style-converter");
var ReportViewStylesDeserializer = /** @class */ (function () {
    function ReportViewStylesDeserializer() {
    }
    ReportViewStylesDeserializer.fromJson = function (stylesJson) {
        var reportViewStyles = stylesJson;
        var title = ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(reportViewStyles.title);
        var subTitle = ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(reportViewStyles.subTitle);
        var header = ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(reportViewStyles.header);
        var footer = ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(reportViewStyles.footer);
        var rowBranchStylesDto = [];
        if (reportViewStyles.rowBranchStylesDto) {
            reportViewStyles.rowBranchStylesDto.forEach(function (rowBranchStyle) {
                rowBranchStylesDto.push(ReportViewStylesDeserializer.convertJsonToRowBranchStyleDto(rowBranchStyle));
            });
        }
        var columnBranchStylesDto = [];
        if (reportViewStyles.columnBranchStylesDto) {
            reportViewStyles.columnBranchStylesDto.forEach(function (columnBranchStyle) {
                columnBranchStylesDto.push(ReportViewStylesDeserializer.convertJsonToColumnBranchStyleDto(columnBranchStyle));
            });
        }
        return new report_view_styles_1.ReportViewStyles(title, subTitle, header, footer, rowBranchStylesDto, columnBranchStylesDto);
    };
    ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto = function (json) {
        var obj;
        if (json) {
            var text = ReportViewStylesDeserializer.convertJsonToMultilingualString(json.texts);
            var textStyle = text_style_converter_1.TextStyleConverter.convertJsonToTextStyleDto(json.textStyle);
            obj = new idm_report_export_service_client_js_1.MultilingualStyledTextDto(text, textStyle);
        }
        return obj;
    };
    ReportViewStylesDeserializer.convertJsonToMultilingualString = function (json) {
        var values = new Map();
        if (json) {
            for (var _i = 0, _a = Object.keys(json); _i < _a.length; _i++) {
                var key = _a[_i];
                values.set(+key, json[key]);
            }
        }
        return new idm_crosscutting_concepts_frontend_1.MultilingualString(values);
    };
    ReportViewStylesDeserializer.convertJsonToRowBranchStyleDto = function (rowStyle) {
        var rowBranchStylesDto = new idm_report_export_service_client_js_1.RowBranchStylesDto();
        if (rowStyle) {
            rowBranchStylesDto.branchIndex = rowStyle.branchIndex;
            var categoriesStyle = new Map();
            var styles = rowStyle.categoriesStyle;
            var i = 0;
            var values = Object.values(styles);
            for (var _i = 0, _a = Object.keys(styles); _i < _a.length; _i++) {
                var key = _a[_i];
                var current = values[i];
                var rowCategoryStyleDto = new idm_report_export_service_client_js_1.RowCategoryStyleDto();
                rowCategoryStyleDto.isDisplayInSeparateColumn = current['isDisplayInSeparateColumn'];
                rowCategoryStyleDto.totalStyle = text_style_converter_1.TextStyleConverter.convertJsonToTextStyleDto(current['totalStyle']);
                rowCategoryStyleDto.numberingStyle = numbering_style_converter_1.NumberingStyleConverter.covert(current['numberingStyle']);
                if (current['rowFormattingRule']) {
                    rowCategoryStyleDto.rowFormattingRule = row_formatting_rule_converter_1.RowFormattingRuleConverter.convertJsonToRowFormattingRule(current['rowFormattingRule']);
                }
                else {
                    rowCategoryStyleDto.rowFormattingRule = new idm_report_export_service_client_js_1.RowFormattingRuleImpl([]);
                }
                ReportViewStylesDeserializer.convertReportElementStyleDto(rowCategoryStyleDto, current);
                categoriesStyle.set(+key, rowCategoryStyleDto);
                ++i;
            }
            rowBranchStylesDto.categoriesStyle = categoriesStyle;
        }
        return rowBranchStylesDto;
    };
    ReportViewStylesDeserializer.convertJsonToColumnBranchStyleDto = function (columnStylesJson) {
        var columnBranchStylesDto = new idm_report_export_service_client_js_1.ColumnBranchStylesDto();
        if (columnStylesJson) {
            columnBranchStylesDto.branchIndex = columnStylesJson.branchIndex;
            if (columnStylesJson.measureStyle) {
                var measureStyle = new idm_report_export_service_client_js_1.ColumnMeasureStyleDto();
                ReportViewStylesDeserializer.convertReportElementStyleDto(measureStyle, columnStylesJson.measureStyle);
                var format = columnStylesJson.measureStyle.measureValueFormat;
                if (format) {
                    measureStyle.measureValueFormat = ReportViewStylesDeserializer.convertMeasureValueFormatDto(format);
                }
                if (columnStylesJson.measureStyle.numberMeasureValueRenderingType) {
                    measureStyle.numberMeasureValueRenderingType = new idm_report_export_service_client_js_1.MeasureValueRenderingType(columnStylesJson.measureStyle.numberMeasureValueRenderingType);
                }
                else {
                    measureStyle.numberMeasureValueRenderingType = new idm_report_export_service_client_js_1.MeasureValueRenderingType(idm_report_export_service_client_js_1.MeasureValueRenderingType.AS_ORIGINAL_NUMBER);
                }
                if (columnStylesJson.measureStyle.columnFormattingRule) {
                    measureStyle.columnFormattingRule = column_formatting_rule_converter_1.ColumnFormattingRuleConverter.convertJsonToColumnFormattingRule(columnStylesJson.measureStyle.columnFormattingRule);
                }
                else {
                    measureStyle.columnFormattingRule = new idm_report_export_service_client_js_1.ColumnFormattingRuleImpl([]);
                }
                columnBranchStylesDto.measureStyle = measureStyle;
            }
            var categoriesStyle = new Map();
            var styles = columnStylesJson.categoriesStyle;
            var i = 0;
            var values = Object.values(styles);
            for (var _i = 0, _a = Object.keys(columnStylesJson.categoriesStyle); _i < _a.length; _i++) {
                var key = _a[_i];
                var current = values[i];
                var columnCategoryStyleDto = new idm_report_export_service_client_js_1.ColumnCategoryStyleDto();
                columnCategoryStyleDto.totalStyle = text_style_converter_1.TextStyleConverter.convertJsonToTextStyleDto(current['totalStyle']);
                columnCategoryStyleDto.numberMeasureValueRenderingType = new idm_report_export_service_client_js_1.MeasureValueRenderingType(current['numberMeasureValueRenderingType']);
                ReportViewStylesDeserializer.convertReportElementStyleDto(columnCategoryStyleDto, current);
                categoriesStyle.set(+key, columnCategoryStyleDto);
                ++i;
            }
            columnBranchStylesDto.categoriesStyle = categoriesStyle;
        }
        return columnBranchStylesDto;
    };
    ReportViewStylesDeserializer.convertReference = function (referenceJsonObject) {
        if (referenceJsonObject) {
            var referenceNumber = ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(referenceJsonObject.referenceNumber);
            var referenceText = ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(referenceJsonObject.referenceText);
            return new idm_report_export_service_client_js_1.ReferenceDto(referenceNumber, referenceText);
        }
        return null;
    };
    ReportViewStylesDeserializer.convertReportElementStyleDto = function (elementToApply, jsonObject) {
        if (jsonObject.valueStyle) {
            elementToApply.valueStyle = text_style_converter_1.TextStyleConverter.convertJsonToTextStyleDto(jsonObject.valueStyle);
        }
        if (jsonObject.alias) {
            elementToApply.alias = ReportViewStylesDeserializer.convertJsonToMultilingualString(jsonObject.alias.texts);
        }
        if (jsonObject.aliasStyle) {
            elementToApply.aliasStyle = text_style_converter_1.TextStyleConverter.convertJsonToTextStyleDto(jsonObject.aliasStyle);
        }
        if (jsonObject.reference) {
            elementToApply.reference = ReportViewStylesDeserializer.convertReference(jsonObject.reference);
        }
        if (jsonObject.width) {
            elementToApply.width = jsonObject.width;
        }
        if (jsonObject.view !== undefined) {
            elementToApply.view = jsonObject.view;
        }
    };
    ReportViewStylesDeserializer.convertMeasureValueFormatDto = function (format) {
        var measureValueFormat = new idm_report_export_service_client_js_1.MeasureValueFormatDto();
        measureValueFormat.numberShowFormat = idm_report_export_service_client_js_1.NumberShowFormat[format.numberShowFormat];
        measureValueFormat.formattingPattern = format.formattingPattern;
        measureValueFormat.isShowInPercentage = format.isShowInPercentage;
        if (format.suffixText) {
            measureValueFormat.suffixText = ReportViewStylesDeserializer.convertJsonToMultilingualString(format.suffixText.texts);
        }
        if (format.prefixText) {
            measureValueFormat.prefixText = ReportViewStylesDeserializer.convertJsonToMultilingualString(format.prefixText.texts);
        }
        return measureValueFormat;
    };
    return ReportViewStylesDeserializer;
}());
exports.ReportViewStylesDeserializer = ReportViewStylesDeserializer;
//# sourceMappingURL=report-view-styles-deserializer.js.map